import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #1a0d2e;
    --navy: #2d1b4e;
    --light-navy: #4a2c6a;
    --lightest-navy: #6b4c87;
    --navy-shadow: rgba(26, 13, 46, 0.7);
    --dark-slate: #7a9b7c;
    --slate: #a8d1aa;
    --light-slate: #c4e8c6;
    --lightest-slate: #e0f7e2;
    --white: #f0fff0;
    --green: #e066ff;
    --green-tint: rgba(224, 102, 255, 0.1);
    --pink: #ff66ff;
    --blue: #b366ff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
